import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import {
  getFirestore,
  query,
  collection,
  orderBy,
} from "firebase/firestore";
import {getStorage} from "firebase/storage"

// firebase init
const firebaseConfig = {
  apiKey: "AIzaSyBarA4lndWR9Md4pP3knoXNGirUO8AiJjM",

  authDomain: "aksali-d1990.firebaseapp.com",

  databaseURL:
    "https://aksali-d1990-default-rtdb.asia-southeast1.firebasedatabase.app",

  projectId: "aksali-d1990",

  storageBucket: "aksali-d1990.appspot.com",

  messagingSenderId: "462673383583",

  appId: "1:462673383583:web:5c3b725020d2a3e52752aa",

  measurementId: "G-N0GHDZFLZH",
};
const fbConfig = initializeApp(firebaseConfig);

// utils
const db = getFirestore(fbConfig);
const auth = getAuth(fbConfig);
const storageRef = getStorage(fbConfig);

// collection references
const usersCollection = query(collection(db, "users"));
const postsCollection = query(
  collection(db, "posts"),
  orderBy("createdOn", "desc")
);
const commentsCollection = query(collection(db, "comments"));

// export utils/refs

export {
  db,
  auth,
  usersCollection,
  postsCollection,
  commentsCollection,
  storageRef,
};
